import React, { FC } from 'react'

import { EuiFormRow, EuiSpacer, EuiTitle } from '@elastic/eui'

import { CampaignType, SegmentTarget, ThirdPartyAudience } from 'api/interfaces'
import { NewSegmentFinder } from 'components/finders/NewSegmentFinder'
import { AudienceTargeterDetailed } from 'components/targeters/AudienceTargeterDetailed'

export interface ModernAudienceTargeterProps {
  title: string
  campaignType?: CampaignType
  segments: SegmentTarget[]
  onSegmentClicked: (segment: SegmentTarget) => void
  onAudienceRemoved: (audience: ThirdPartyAudience) => void
}

const ModernAudienceTargeter: FC<ModernAudienceTargeterProps> = ({ title, campaignType, segments, onSegmentClicked, onAudienceRemoved }) => {
  return (
    <>
      <EuiTitle size='s'>
        <span>{title}</span>
      </EuiTitle>
      <EuiSpacer size='s' />
      <EuiFormRow label='Search for unique audience characteristics (i.e. homeowners, luxury goods, etc.)' fullWidth>
        <NewSegmentFinder campaignType={campaignType === CampaignType.TV ? CampaignType.TV : campaignType === CampaignType.Audio ? CampaignType.Audio : CampaignType.Internet} isInvalid={false} onSegmentClicked={onSegmentClicked} />
      </EuiFormRow>
      {(segments?.length ?? 0) > 0 && (
        <EuiFormRow fullWidth label='Your campaign will prioritize individuals in any of these categories'>
          <AudienceTargeterDetailed
            audiences={segments.map(s => ({
              id: s.id,
              name: s.name,
              description: s.description ?? '',
              provider: '',
              reachCount: -1,
              price: -1,
              hierarchy: [],
              sourceDetails: ''
            }))}
            onAudienceRemoved={onAudienceRemoved}
          />
        </EuiFormRow>
      )}
    </>
  )
}

export default ModernAudienceTargeter
